import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, centersTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteCenterAction } from "redux/reducers/centersReducer"
import { AppColors } from "resources/AppColors"

function DeleteCenterDialog() {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteCenter() {
    dispatch(deleteCenterAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate('/gestio-dels-centres')
  }

  return (
    <CustomDialog
      title={centersTexts.DELETED_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {centersTexts.DELETED_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteCenter}
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteCenterDialog